import axios from 'axios';
import { Message } from 'element-ui';

axios.defaults.timeout = 5000;
console.log(process.env.NODE_ENV)

if (process.env.NODE_ENV == 'development') {
  // axios.defaults.baseURL = '';
}
else if (process.env.NODE_ENV == 'debug') {
  // axios.defaults.baseURL = '';
}
else if (process.env.NODE_ENV == 'production') {
  // axios.defaults.baseURL = '';
  // 全局配置，生产环境取消 console.log 的控制台输出
  let sign = false
  console.log = (function (oriLogFunc) {
    return function () {
      if (sign) {
        oriLogFunc.apply(this, arguments);
      }
    }
  })(console.log)
}

//http request 拦截器
axios.interceptors.request.use(
    config => {
        // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
        config.data = JSON.stringify(config.data);
        config.headers = {
            'Content-Type':'application/json'
        }
        // if(token){
        //   config.params = {'token':token}
        // }
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);


//http response 拦截器
axios.interceptors.response.use(
    // response => {
    //     if(response.data.errCode ==2){
    //         router.push({
    //             path:"/login",
    //             querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
    //         })
    //     }
    //     return response;
    // },
    // error => {
    //     return Promise.reject(error)
    // }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url,params={}){
    return new Promise((resolve,reject) => {
        axios.get(url,{
            params:params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url,data = {}){
    return new Promise((resolve,reject) => {
        axios.post(url,data)
            .then(response => {
                resolve(response.data);
            },err => {
                reject(err)
            })
    })
}

export const getLoginType = () => {
    let userData = JSON.parse(localStorage.getItem("userData"));
    return userData.logintype;
}
